import React from 'react'
import { Helmet } from 'react-helmet-async'
import { PawPrintIcon } from "lucide-react"
import { config } from "@/lib/config"
import PreOrder from "@/components/main/preorder"

const PreOrderTitle = () => {
  return (
    <>
      <div className="mb-4 flex flex-col items-center justify-center">
        <img
          src={`${config.basePath}/images/macstar2.jpg`}
          alt="2025 logo"
          className="w-[60%] object-cover"
        />
      </div>
      <div className="mb-4 text-2xl font-bold">Előrendelés</div>
      <div className="mb-2 text-3xl font-bold">
        MacsTár Naptár &mdash; Színes hónapok
      </div>
      <div className="text-sm font-normal">
        Naptár 12 letölthető gyakorlattal
      </div>
      <div className="m-4 justify-items-start border-2 border-amber-900 text-left text-sm font-normal">
        <div className="m-4 text-sm">
          <div className="mb-4 text-xl font-bold">
            Kreatív alkotó naptár: Stresszmentes és kreatív mindennapok macskák
            társaságában!
          </div>

          <div className="text-lg font-bold">Mit találsz a naptárban</div>
          <ul className="">
            <li className="mb-2 mt-2">
              <div className="flex">
                <PawPrintIcon className="mr-2 text-lg text-green-600" />
                <div className="text-sm">
                  12 cuki macska: Mindegyik más-más stílusban és művészeti
                  eszközzel készült
                </div>
              </div>
            </li>
            <li className="mb-2 mt-2">
              <div className="flex">
                <PawPrintIcon className="mr-2 text-lg text-green-600" />
                <div className="text-sm">
                  12 kreatív önismereti gyakorlat: Letölthető, felnőtteknek
                  szóló feladatok,
                  <br /> amelyek 12 művészetterápiás eszközzel készültek és amik
                  segítenek a stresszoldásban és a kreatív energiák
                  felszabadításában
                </div>
              </div>
            </li>
            <li className="mb-2 mt-2">
              <div className="flex">
                <PawPrintIcon className="mr-2 text-lg text-green-600" />
                <div className="text-sm">
                  Holnaptár holdfázisokkal: Kísérd figyelemmel a hold mozgását a
                  mindennapjaid tervezéséhez.
                </div>
              </div>
            </li>
          </ul>

          <div className="text-lg font-bold">Miért különleges ez a naptár</div>
          <ul className="">
            <li className="mb-2 mt-2">
              <div className="flex">
                <PawPrintIcon className="mr-2 text-lg text-green-600" />
                <div className="text-sm">
                  Kreativitás: Inspiráló feladatok, amelyek fejlesztik az
                  önkifejezést.
                </div>
              </div>
            </li>
            <li className="mb-2 mt-2">
              <div className="flex">
                <PawPrintIcon className="mr-2 text-lg text-green-600" />
                <div className="text-sm">
                  Stresszoldás: Alkotás közben levezetheted a mindennapi
                  feszültséget.
                </div>
              </div>
            </li>
            <li className="mb-2 mt-2">
              <div className="flex">
                <PawPrintIcon className="mr-2 text-lg text-green-600" />
                <div className="text-sm">
                  Tökéletes ajándék minden macskarajongónak – a karácsonyfa alá
                  is!
                </div>
              </div>
            </li>
          </ul>

          <div className="mb-4 mt-4 text-xl font-bold">
            Vigyázz, addiktív tartalom!
          </div>
          <div className="mb-4 mt-4 italic">
            Macskaimádóknak kötelező ajándék a karácsonyfa alá!:-)
          </div>
          <div className="text-sm font-bold">
            Kreativitás, önismeret, alkotás, öröm, fejlődés!
          </div>
          <div className="mt-4">
            <div>
              <div className="mb-2 font-bold">A MACS-tár jelentése</div>
              Macska naptár, avagy Művészetterápiás Alkotógyakorlatok CSokra
              naptár!
            </div>

            <div className="mt-2">
              12 hónapra 12 különböző stílusú macska, 12 művészetterápiás
              eszközzel készített felnőtteknek szóló kreatív önismereti
              gyakorlat, amelyek segítenek a stresszoldásban, a mindennapi
              stressz levezetésében, emellett a kreativitást és önkifejezést
              fejlesztik.
            </div>

            <div className="mt-2">
              A gyakorlatokat a naptáron található QR kóddal tudod letölteni.
            </div>

            <div className="mt-4 font-bold">Jó alkotást!</div>
          </div>

          <div className="mt-4">
            <div className="mt-2">
              <div className="font-bold">A csomag ára:</div>
              8900 Ft/db +1140 Ft szállítási költség
            </div>
            <div>
              12+1 lapos, spirálozott naptár, akasztóval, A4-es méretben (+ QR
              kóddal letölthető digitális tartalom).
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default function Download2025() {
  return (
    <>
      <Helmet>
        <title>2025 Naptár | BeArt Művészetterápia</title>
        <meta name="description" content="BeArt Művészetterápia, Art Coaching, családállítás, coaching, önismeret - művészetterápiás csoportok, egyéni és csoportos alkalmak, szervezeteknek kiégés megelőzés programok, önismereti foglalkozások" />
        <link rel="canonical" href="https://beart.hu/2025" />
      </Helmet>
      
      <section className="mx-auto mb-8 mt-8 flex w-3/4 rounded-lg bg-[#ffcc99] bg-opacity-50 text-black shadow">
        <PreOrder title={<PreOrderTitle />} hidden="naptar"></PreOrder>
      </section>
      <div className="mx-auto w-3/4">
        <p>
          <strong>Adatkezelési tájékoztatás:</strong> Az űrlap kitöltésével
          hozzájárulsz adataid kommunikáció és kapcsolattartás céljára történő
          kezeléséhez. Az Európai Parlament és Tanács (EU) 2016/679. rendelete
          (továbbiakban: GDPR) a személyes adatok kezelésére vonatkozó rendelete
          az irányadó az adatok kezelésében.
        </p>
      </div>
    </>
  )
}
